export const configurationSource = {
  accessories: 'accessories',
  model: 'model'
};